import React from "react";
import { Menu } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  PhoneOutlined,
  TeamOutlined,
  CrownOutlined,
  ShoppingCartOutlined,
  WarningOutlined,
  AlertOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  FlagOutlined,
  FilterOutlined,
  DeliveredProcedureOutlined,
  UndoOutlined,
  RocketOutlined,
  ScheduleOutlined,
  AimOutlined,
  SettingOutlined,
  UserSwitchOutlined,
  LogoutOutlined,
  MessageOutlined,
  StarOutlined,
  BulbOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useParams } from "react-router-dom";
import { RiBikeLine, RiFileListLine } from "react-icons/ri";
import {
  IoBagOutline,
  IoChatbox,
  IoChatboxOutline,
  IoCheckboxOutline,
  IoCheckmarkOutline,
  IoExpandOutline,
  IoGrid,
  IoGridOutline,
  IoReturnUpBack,
} from "react-icons/io5";
import {
  MdBikeScooter,
  MdDisabledVisible,
  MdPointOfSale,
  MdStar,
  MdStarBorder,
} from "react-icons/md";
import SubMenu from "antd/es/menu/SubMenu";
import { useDispatch, useSelector } from "react-redux";
import { logoutAdmin } from "../actions/AuthAction";
import { isPermitted } from "../utils/PermissionManager";
const SideMenu = () => {
  const location = useLocation();

  let profile = useSelector((state) => state.auth?.profile);
  const roles = useSelector((state) => state.auth.profile?.roles);

  const dispatch = useDispatch();

  let accessCrm = localStorage.getItem("accessCrm")
    ? JSON.parse(localStorage.getItem("accessCrm"))
    : null;

  let currentProfile = accessCrm || profile;


  const getAccessAble = () => {
    return true;
  };

  const getAccessAbleOneTwo = () => {
    if (currentProfile?.crm?.manager_type === 1 || currentProfile?.crm?.manager_type === 2 || isPermitted(roles, ["admin"])) {
      return true;
    }
    return false
  };

  let sitePath = location.pathname;
  if (location.search?.length > 2) {
    sitePath += location.search;
  }
  return (
    <Menu
      mode="inline"
      selectedKeys={[sitePath]}
      className="side-menu"
      defaultOpenKeys={["skybuy", "skyship"]}
    >
      {" "}
      <Menu.Item key="/" icon={<DashboardOutlined />}>
        {" "}
        <Link to="/">Dashboard</Link>{" "}
      </Menu.Item>{" "}

      {isPermitted(roles, ["admin", "crm_team_leader"]) && <SubMenu key="skyship" title="Admin" icon={<RocketOutlined />}>
        {isPermitted(roles, ["admin"]) && (
          <Menu.Item key="/managers" icon={<SettingOutlined />}>
            {" "}
            <Link to="/managers">Managers</Link>{" "}
          </Menu.Item>
        )}
        {isPermitted(roles, ["admin", "crm_team_leader"]) && (
          <Menu.Item key="/manager-targets" icon={<AimOutlined />}>
            {" "}
            <Link to="/manager-targets">Manager Targets</Link>{" "}
          </Menu.Item>
        )}
        {isPermitted(roles, ["admin"]) && (
          <Menu.Item key="/leader-targets" icon={<AimOutlined />}>
            {" "}
            <Link to="/leader-targets">Leader Targets</Link>{" "}
          </Menu.Item>
        )}
      </SubMenu>}


      <Menu.Item
        key="/chat"
        icon={<MessageOutlined style={{ fontSize: "14px", width: "18px" }} />}
      >
        <Link to={"/chat"}>Customer Chat</Link>
      </Menu.Item>
      {getAccessAbleOneTwo() && <Menu.Item
        key="/chat-china"
        icon={<IoChatboxOutline style={{ fontSize: "14px", width: "18px" }} />}
      >
        <Link to={"/chat-china"}>China Chat</Link>
      </Menu.Item>}
      {/* {getAccessAbleHotline() && <SubMenu key="hotline" title="Hotline" icon={<PhoneOutlined />}>
        <Menu.Item
          key={`/hotline-customers`}
          icon={<UserSwitchOutlined />}
        >
          <Link to={`/hotline-customers`}>Customers</Link>
        </Menu.Item>
        <Menu.Item key={`/hotline-orders`} icon={<ShoppingCartOutlined />}>
          <Link to={`/hotline-orders`}>Orders</Link>
        </Menu.Item>
      </SubMenu>} */}
      {/* {getAccessAbleOneTwo() && <SubMenu key="skybuy" title="Skybuy" icon={<IoBagOutline />}>
        {" "} */}
      <Menu.Item key={`/sky-crm?tab=customer`} icon={<UserSwitchOutlined />}>
        {" "}
        <Link to={`/sky-crm?tab=customer`}>Customer</Link>{" "}
      </Menu.Item>{" "}

      <Menu.Item key="/sky-crm?tab=call+task" icon={<PhoneOutlined />}>
        <Link to="/sky-crm?tab=call+task">Call Task</Link>
      </Menu.Item>
      <Menu.Item key="/sky-crm?tab=scheduled+tasks" icon={<ScheduleOutlined />}>
        <Link to="/sky-crm?tab=scheduled+tasks">Scheduled Tasks</Link>
      </Menu.Item>
      <Menu.Item key={`/sky-crm?tab=ideas`} icon={<BulbOutlined />}>
        <Link to={`/sky-crm?tab=ideas`}>Ideas</Link>
      </Menu.Item>
      {/* <Menu.Item key={`/sky-crm?tab=ideas`} icon={<BulbOutlined />}>
        <Link to={`/sky-crm?tab=ideas`}>Ideas</Link>
      </Menu.Item>
      <Menu.Item key={`/sky-crm?tab=office-complains`} icon={<WarningOutlined />}>
        <Link to={`/sky-crm?tab=office-complains`}>Office Complains</Link>
      </Menu.Item> */}
      {getAccessAbleOneTwo() && <>
        {getAccessAble() && (
          <Menu.Item
            key={`/sky-crm?tab=active+customer`}
            icon={<UserOutlined />}
          >
            <Link to={`/sky-crm?tab=active+customer`}>Active Customer</Link>
          </Menu.Item>
        )}
        {getAccessAble() && (
          <Menu.Item
            key={`/sky-crm?tab=inactive+customer`}
            icon={<TeamOutlined />}
          >
            <Link to={`/sky-crm?tab=inactive+customer`}>Inactive Customer</Link>
          </Menu.Item>
        )}
        {getAccessAble() && (
          <Menu.Item
            key={`/sky-crm?tab=point+customer`}
            icon={<CrownOutlined />}
          >
            <Link to={`/sky-crm?tab=point+customer`}>Point Customer</Link>
          </Menu.Item>
        )}
        <Menu.Item key={`/sky-crm?tab=orders`} icon={<ShoppingCartOutlined />}>
          <Link to={`/sky-crm?tab=orders`}>Orders</Link>
        </Menu.Item>
        <Menu.Item
          key={`/sky-crm?tab=sea+orders`}
          icon={<ShoppingCartOutlined />}
        >
          <Link to={`/sky-crm?tab=sea+orders`}>Sea Orders</Link>
        </Menu.Item>
        <Menu.Item
          key={`/sky-crm?tab=slow+orders`}
          icon={<MdDisabledVisible />}
        >
          <Link to={`/sky-crm?tab=slow+orders`}>Slow Orders</Link>
        </Menu.Item>
        {getAccessAbleOneTwo() && <SubMenu key="purchase" title="Purchase" icon={<IoBagOutline />}>
          <Menu.Item
            key={`/sky-crm?tab=approval+center`}
            icon={<IoCheckmarkOutline />}
          >
            <Link to={`/sky-crm?tab=approval+center`}>Approval Center</Link>
          </Menu.Item>
          <Menu.Item
            key={`/sky-crm?tab=confirmation+center`}
            icon={<IoCheckboxOutline />}
          >
            <Link to={`/sky-crm?tab=confirmation+center`}>
              Confirmation Center
            </Link>
          </Menu.Item>
        </SubMenu>}
        {/* <Menu.Item
          key={`/sky-crm?tab=verify+purchase`}
          icon={<IoExpandOutline />}
        >
          <Link to={`/sky-crm?tab=verify+purchase`}>Verify Purchase</Link>
        </Menu.Item>
        <Menu.Item key={`/sky-crm?tab=risky`} icon={<WarningOutlined />}>
          <Link to={`/sky-crm?tab=risky`}>Risky</Link>{" "}
        </Menu.Item>{" "} */}
        <Menu.Item key={`/sky-crm?tab=tickets`} icon={<AlertOutlined />}>
          {" "}
          <Link to={`/sky-crm?tab=tickets`}>Support</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item key={`/sky-crm?tab=complains`} icon={<WarningOutlined />}>
          {" "}
          <Link to={`/sky-crm?tab=complains`}>Complains</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item key={`/sky-crm?tab=qc`} icon={<CheckCircleOutlined />}>
          {" "}
          <Link to={`/sky-crm?tab=qc`}>QC</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item
          key={`/sky-crm?tab=customer+qc`}
          icon={<CheckCircleOutlined />}
        >
          {" "}
          <Link to={`/sky-crm?tab=customer+qc`}>Customer QC</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item
          key={`/sky-crm?tab=order+report`}
          icon={<FileTextOutlined />}
        >
          {" "}
          <Link to={`/sky-crm?tab=order+report`}>Order Report</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item
          key={`/sky-crm?tab=monthly+badge+report`}
          icon={<StarOutlined />}
        >
          <Link to={`/sky-crm?tab=monthly+badge+report`}>
            Monthly Badge Report
          </Link>
        </Menu.Item>
        <Menu.Item key="/sky-crm?tab=badge+customer+report" icon={<UserOutlined />}>
          <Link to="/sky-crm?tab=badge+customer+report">Badge Customer Report</Link>
        </Menu.Item>

        <Menu.Item key={`/sky-crm?tab=target`} icon={<FlagOutlined />}>
          {" "}
          <Link to={`/sky-crm?tab=target`}>Target</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item key={`/sky-crm?tab=sorting`} icon={<FilterOutlined />}>
          {" "}
          <Link to={`/sky-crm?tab=sorting`}>Sorting</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item
          key={`/sky-crm?tab=delivery`}
          icon={<DeliveredProcedureOutlined />}
        >
          {" "}
          <Link to={`/sky-crm?tab=delivery`}>Delivery</Link>{" "}
        </Menu.Item>{" "}
        <Menu.Item
          key={`/sky-crm?tab=steadfast+return`}
          icon={<UndoOutlined />}
        >
          {" "}
          <Link to={`/sky-crm?tab=steadfast+return`}>
            Steadfast Return
          </Link>{" "}
        </Menu.Item>{" "}

        {/* </SubMenu>} */}
      </>}
      <Menu.Item
        key="/logout"
        onClick={() => {
          dispatch(
            logoutAdmin(() => {
              window.location.href = "/login";
            }),
          );
        }}
        icon={<LogoutOutlined style={{ fontSize: "16px", width: "18px" }} />}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
};
export default SideMenu;
